import { cloneElement, useEffect, useState } from 'react';
import useResizeObserver from '@react-hook/resize-observer';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useMFModal } from '@medifind/popups';
import { Button } from '@medifind/shared-basic-components';
import { useMediaQueryDown } from '@medifind/utils';
import { FilterContext } from '../filters/Filter';
import styles from './FilterModal.module.scss';

const FilterModal = ({
  children,
  clearFilters,
  filterButton,
  filterButtonLabel,
  resultsText,
  iconBefore,
  classes = {},
  smallAt,
  title,
  parentContainer,
  style = {},
  hideFilterButtonAt,
}) => {
  const filterButtonBreakpoint = useMediaQueryDown(hideFilterButtonAt);
  const { MFModal, openModal, closeModal } = useMFModal();
  const [ref, setRef] = useState();
  const useRect = (target) => {
    const [rect, setRect] = useState();
    useResizeObserver(target, (entry) => setRect(entry.contentRect));
    return rect;
  };
  const rect = useRect(ref);
  useEffect(() => {
    if (ref) ref.scrollTo(0, 10000);
  }, [rect, ref]);

  return (
    <>
      <MFModal
        title={title}
        parentContainer={parentContainer}
        style={style}
        classes={{ modalBody: classNames(styles['modal-body'], classes.modalBody) }}
        footer={
          <div className={styles['filters__buttons-wrapper']}>
            <Button
              classes={{ container: styles['filters__button'] }}
              focus={'outline'}
              color={'red'}
              label="Apply filters"
              onClick={closeModal}
            />
            {clearFilters && (
              <Button
                classes={{ container: styles['filters__button'] }}
                focus={'outline'}
                color={'inverted-blue'}
                label="Reset all"
                onClick={clearFilters}
              />
            )}
            {resultsText ? <div className={styles['filters__total-results']}>{resultsText}</div> : null}
          </div>
        }
      >
        <div className={styles['filters']} ref={setRef}>
          <div className={classNames(classes.modalFiltersWrapper, styles['filters-wrapper'])}>{children}</div>
        </div>
      </MFModal>
      <FilterContext.Provider value={{ onClickSmall: openModal }}>
        {filterButton ? (
          <>
            {filterButtonBreakpoint && (
              <Button
                onClick={openModal}
                focus={'underline'}
                color={'thin-grey-border'}
                label={filterButtonLabel ? filterButtonLabel : 'Filters'}
                type={'box'}
                shape={'round'}
                iconBefore={iconBefore}
                className={classNames(classes.modalFiltersButton, styles['filters__button'])}
                style={{
                  ...(style.filterButton || {}),
                }}
              >
                Filters
              </Button>
            )}
          </>
        ) : (
          cloneElement(children, { smallAt })
        )}
      </FilterContext.Provider>
    </>
  );
};

FilterModal.propTypes = {
  clearFilters: PropTypes.func,
  children: PropTypes.node.isRequired,
  filterButton: PropTypes.bool,
  filterButtonLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  resultsText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  classes: PropTypes.object,
  smallAt: PropTypes.string,
  title: PropTypes.string.isRequired,
  parentContainer: PropTypes.string,
  style: PropTypes.object,
  hideFilterButtonAt: PropTypes.string,
};

export { FilterModal as default, FilterModal };
